import React from 'react';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import SettingsIcon from '@material-ui/icons/Settings';
import LockIcon from '@material-ui/icons/Lock';
import { confirm } from '../../../utils';
import { postStepStatus } from '../../../Containers/Partners/service/partnersApi/actions';
import './style.scss';

// Onboarding null → popup "Contactez votre partenaire pour en savoir plus"
const handleMoreInfo = () => {
	confirm(I18n.t('partner.call_partner_support'), {
		title: I18n.t('general.information'),
		confirmLabel: I18n.t('general.close'),
		hideCancel: true,
	});
};

/**
 * Carte partenaire — état "Non configuré".
 * Base neuve : composant présentationnel, alimenté par le partenaire
 * (logo + description fournis par l'API /partners/all).
 *
 * CTA selon onboarding.type :
 *   - null      -> "En savoir plus"   (handleMoreInfo)
 *   - external  -> "Configurer"       (POST step-status, même 1er appel que la config card au step "initial") : passe le
 *                                       partenaire en "configuré" et redirige vers le lien externe.
 *   - internal  -> "Configurer"       → POST step-status (même 1er appel que la
 *                                       config card au step "initial") : passe le
 *                                       partenaire en "configuration".
 *
 * connector_data.access pilote l'état verrouillé :
 *   - access        -> icône engrenage + libellé ci-dessus
 *   - !access       -> icône cadenas fermé + libellé "Débloquer"
 *
 * @param {Object} props.partner partenaire renvoyé par /partners/all
 */
const CardUnconfigured = ({ partner = {}, postStepStatus, onConfigure }) => {
	const { logo, description, name, prefix, onboarding } = partner;

	const title = name || (prefix ? I18n.t(`partner.prefix.${prefix}`) : '');

	const type = onboarding ? onboarding.type : null;
	const link = onboarding ? onboarding.link : null;

	const connectorData = partner.connector_data || { access: true, free: true };
	const locked = !connectorData.access;

	let ctaLabel;
	let onCtaClick;
	if (type === 'external') {
		ctaLabel = I18n.t('partner.configuration'); // Configurer
		onCtaClick = () => postStepStatus({ prefix, data: {} });
	} else if (type === 'internal') {
		ctaLabel = I18n.t('partner.configuration'); // Configurer
		onCtaClick = () => {
			postStepStatus({ prefix, data: {} });
			if (onConfigure) onConfigure(prefix);
			window.scrollTo({ top: 0, behavior: 'smooth' });
		};
	} else {
		ctaLabel = I18n.t('partner.more_info'); // En savoir plus
		onCtaClick = handleMoreInfo;
	}

	// Connecteur payant non débloqué : on n'onboarde pas, on affiche juste un
	// message invitant à contacter le commercial l'Addition.
	if (locked) {
		ctaLabel = I18n.t('partner.unlock'); // Débloquer
		onCtaClick = () => {
			confirm(I18n.t('partner.locked_connector_info'), {
				title: I18n.t('general.information'),
				confirmLabel: I18n.t('general.close'),
				hideCancel: true,
			});
		};
	}

	return (
		<div className="card-unconfigured">
			<div className="card-unconfigured__logo">
				{logo ? (
					<img src={logo} alt={`Logo ${title}`} />
				) : (
					<span className="card-unconfigured__title">{title}</span>
				)}
			</div>

			<p className="card-unconfigured__description">{description}</p>

			<div className="card-unconfigured__action">
				<button
					type="button"
					className="card-unconfigured__cta"
					onClick={onCtaClick}>
					<span>{ctaLabel}</span>
					{locked ? <LockIcon /> : <SettingsIcon />}
				</button>
			</div>
		</div>
	);
};

export default connect(null, { postStepStatus })(CardUnconfigured);
